import React from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

type PropType = {
  loading: any;
  creditNoteId?: string;
  creditNote: any;
};

const CreditNoteSidebar: React.FC<PropType> = (props) => {
  const { creditNote, loading, creditNoteId } = props;

  const navigate = useNavigate();
  return (
    <>
      <div className="">
        <div className="person_name_wrapper viewlead_content_header justify-content-between">
          <div
            className="cursor_pointer d-flex align-items-center"
            onClick={() => navigate("/credit-note")}
          >
            <img
              src="/Assets/Svg/backBtn.svg"
              alt="close"
              width={13}
              height={13}
            />
            <h3 className="mb-0 font14x600 textColor3 d-inline-block ms-2">
              Back
            </h3>
          </div>
          <div className="">
            <button
              className="btn font12x500 buttonOne shadow-none"
              onClick={() => navigate("/credit-note/form")}
            >
              <img
                src="/Assets/Svg/plusIcon.svg"
                alt="icon"
                className="me-2"
                width={13}
                height={13}
              />
              New
            </button>
          </div>
        </div>
        <div className="view_doc_menu_wrapper">
          {loading ? (
            <>
              <Skeleton height="50px" borderRadius="4px" />
              <Skeleton height="50px" borderRadius="4px" />
              <Skeleton height="50px" borderRadius="4px" />
              <Skeleton height="50px" borderRadius="4px" />
            </>
          ) : (
            creditNote?.map((item: any, i: number) => {
              return (
                <div
                  className={
                    creditNoteId === item?._id
                      ? "view_single_doc_menu_active"
                      : "view_single_doc_menu"
                  }
                  onClick={() => navigate(`/credit-note/view/${item?._id}`)}
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="mb-0 font12x500 textColor2">
                        {item?.client?.name}
                      </p>
                      <p className="mb-0 font10x400 textColor1">
                        {`${item?.creditNoteNumber}`}
                      </p>
                    </div>
                    <div>
                      <p className="mb-0 font12x500 textColor1">
                        {`₹ ${item?.calculation?.total?.toLocaleString()}`}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};

export default CreditNoteSidebar;
